import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReportDefinitions from '../../../../../common/config/ReportDefinitions';
import DespatchMonitoringReport from '../../common/components/DespatchMonitoringReport';
import {
  getCompactColumns,
  getData,
  getDetailsColumns,
  getGeneratedOnDateTime,
  getIsLoading,
} from '../redux/selectors/DespatchMonitoringEventTargetsSelectors';
import DespatchMonitoringEventTargetsReportMode from './DespatchMonitoringEventTargetsReportMode';

const MODE_TABS = [
  { value: DespatchMonitoringEventTargetsReportMode.compact, label: 'Compact' },
  { value: DespatchMonitoringEventTargetsReportMode.details, label: 'Details' },
];

export class DespatchMonitoringEventTargetsContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      reportMode: DespatchMonitoringEventTargetsReportMode.compact,
    };
  }

  changeMode = reportMode => this.setState({ reportMode });

  renderCompact() {
    return (
      <DespatchMonitoringReport
        reportId={ReportDefinitions.DESPATCH_MONITORING_EVENT_TARGETS.id}
        generatedOnDateTime={this.props.generatedDateTime}
        isLoading={this.props.isLoading}
        data={this.props.data}
        columns={this.props.compactColumns}
        modeTabs={MODE_TABS}
        changeMode={this.changeMode}
        mode={DespatchMonitoringEventTargetsReportMode.compact}
      />
    );
  }

  renderDetails() {
    return (
      <DespatchMonitoringReport
        reportId={ReportDefinitions.DESPATCH_MONITORING_EVENT_TARGETS.id}
        generatedOnDateTime={this.props.generatedDateTime}
        isLoading={this.props.isLoading}
        data={this.props.data}
        columns={this.props.detailsColumns}
        modeTabs={MODE_TABS}
        changeMode={this.changeMode}
        mode={DespatchMonitoringEventTargetsReportMode.details}
      />
    );
  }

  render() {
    switch (this.state.reportMode) {
      case DespatchMonitoringEventTargetsReportMode.compact:
        return this.renderCompact();
      case DespatchMonitoringEventTargetsReportMode.details:
        return this.renderDetails();
      default:
        return (<div id="report-mode-error">Report mode &quot;{this.state.reportMode}&quot; is not implemented</div>);
    }
  }
}

function mapStateToProps(state) {
  return {
    generatedDateTime: getGeneratedOnDateTime(state),
    isLoading: getIsLoading(state),
    data: getData(state),
    compactColumns: getCompactColumns(state),
    detailsColumns: getDetailsColumns(state),
  };
}

DespatchMonitoringEventTargetsContainer.propTypes = {
  generatedDateTime: PropTypes.string,
  isLoading: PropTypes.bool,
  data: PropTypes.arrayOf(PropTypes.object),
  compactColumns: PropTypes.arrayOf(PropTypes.object),
  detailsColumns: PropTypes.arrayOf(PropTypes.object),
};

export default connect(mapStateToProps)(DespatchMonitoringEventTargetsContainer);

